module.exports = "https://web-assets.ifttt.com/packs/media/stencils/plaintext-file-3ebf6ccd.svg";